import { PersistedWorkflowTriggerKind } from './workflow';

/**
 * Whether a new workflow ↔ trigger binding starts switched on, when whoever
 * creates it does not say.
 *
 * Webhooks start off. A webhook may already be receiving a provider's whole
 * event stream when it is bound, so switching it on with the binding runs a
 * half-built workflow against live traffic before anyone has checked it.
 * Turning one on is a deliberate step on the trigger card.
 */
export function triggerBindingEnabledByDefault(kind: string): boolean {
  return kind !== PersistedWorkflowTriggerKind.Webhook;
}
